import React from 'react';

/**
 * Subtle horizontal section break used to "chapter" long demo pages.
 * Kept intentionally low-contrast so it reads as a chapter divider, not a
 * decorative rule. Place it BETWEEN two siblings inside a vertically-stacked
 * parent (e.g., space-y-12) — the parent's space-y already provides the
 * gap, this rule just adds a tasteful visual cue.
 *
 * Forwards extra props (data-testid, className, etc.) so callers can label
 * individual breaks for testing.
 */
const SectionBreak = ({ className = '', ...rest }) => (
  <hr
    aria-hidden="true"
    data-testid={rest['data-testid'] || 'section-break'}
    {...rest}
    className={`border-0 h-px bg-slate-200/70 ${className}`}
  />
);

export default SectionBreak;
